import { OverlayBaseController } from '@ionic/angular/util/overlay';

export function restoreFocusOnDismissPopover(popover: HTMLIonPopoverElement) {
  const currentActiveElement = document.activeElement as HTMLElement | undefined
  popover.onDidDismiss().then(() => {
    currentActiveElement?.focus();
  });
}

export function restoreFocusOnDismissModal(modal: HTMLIonModalElement) {
  const currentActiveElement = document.activeElement as HTMLElement | undefined
  modal.onDidDismiss().then(() => {
    currentActiveElement?.focus();
  });
}

export function restoreFocusOnDismissAlert(alert: HTMLIonAlertElement) {
  const currentActiveElement = document.activeElement as HTMLElement | undefined
  alert.onDidDismiss().then(() => {
    currentActiveElement?.focus();
  });
}

export async function isTopOverlay<T>(overlayController: OverlayBaseController<T, any>, component: any) {
  const top = await overlayController.getTop();
  const isTop = top?.component === component;

  return isTop;
}